<template>
  <div class="flex flex-col h-ekran">
    <!-- Üst bar (SK3-M, V7; SK4-H): menü düğmesi (mobil) · başlık + yol izi · Ctrl+K · zil · tema · Sparqon · kullanıcı -->
    <header class="sk-ust admin-border-bottom bg-surface-0 dark:bg-surface-900 flex items-center gap-2 px-3 h-14 shrink-0 z-50 relative">
      <button type="button" class="md:hidden sk-ikon-dugme" aria-label="Menüyü aç" @click="drawerAcik = true">
        <i class="pi pi-bars text-lg"></i>
      </button>
      <router-link to="/sistem/genel" class="hidden sm:inline-flex items-center gap-2 font-semibold text-gray-800 dark:text-gray-100 shrink-0">
        <i class="pi pi-shield renk-uyari"></i>
        <span>Sistem Konsolu</span>
      </router-link>
      <button v-if="geriVar" type="button" class="sk-ikon-dugme shrink-0" aria-label="Geri" title="Geri" @click="geriTikla">
        <i class="pi pi-arrow-left"></i>
      </button>
      <nav aria-label="Yol izi" class="min-w-0 flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400">
        <span class="hidden sm:inline" aria-hidden="true">›</span>
        <span v-if="aktifGrup" class="hidden sm:inline">{{ aktifGrup.ad }}</span>
        <span v-if="aktifGrup" class="hidden sm:inline" aria-hidden="true">›</span>
        <span class="truncate font-medium text-gray-800 dark:text-gray-100">{{ sayfaAdi }}</span>
      </nav>
      <span class="flex-1"></span>
      <button type="button" class="sk-arama-dugme hidden sm:inline-flex" @click="aramaAc" aria-label="Sayfa ara (Ctrl+K)">
        <i class="pi pi-search"></i>
        <span>Sayfa ara</span>
        <kbd>Ctrl K</kbd>
      </button>
      <button type="button" class="sm:hidden sk-ikon-dugme" aria-label="Sayfa ara" @click="aramaAc">
        <i class="pi pi-search"></i>
      </button>
      <!-- SK4-G/K7: "Panele geç" kalktı — sağlayıcı kiracı panelini kullanmaz; kiracı görünümü
           yalnız Şirket 360 → Şirkete geç. Kişisel işler (bildirim, hesap) konsolda (K8). -->
      <KonsolZil />
      <button type="button" class="sk-ikon-dugme" :aria-label="koyuTema ? 'Açık temaya geç' : 'Koyu temaya geç'"
        :title="koyuTema ? 'Açık temaya geç' : 'Koyu temaya geç'" @click="temaDegistir">
        <i :class="koyuTema ? 'pi pi-sun' : 'pi pi-moon'"></i>
      </button>
      <!-- AB1 (AB-K6): alan boyutu Normal ↔ Küçük -->
      <button type="button" class="sk-ikon-dugme" :aria-label="'Alan boyutu: ' + (kucukMu ? 'Küçük' : 'Normal')"
        :title="'Alan boyutu: ' + (kucukMu ? 'Küçük' : 'Normal')" @click="boyutDegistir">
        <i :class="kucukMu ? 'pi pi-expand' : 'pi pi-compress'"></i>
      </button>
      <!-- SK3-S: sağlayıcı Sparqon'unun düğmesi (_ortak/SistemSparqon.vue) buraya ışınlanır -->
      <div id="sparqon-bar-yuvasi" class="flex items-center"></div>
      <button type="button" class="sk-ikon-dugme" aria-label="Kullanıcı menüsü" @click="(e) => $refs.kullaniciMenu.toggle(e)">
        <i class="pi pi-user"></i>
      </button>
      <Menu ref="kullaniciMenu" :model="kullaniciMenuOgeleri" popup>
        <!-- OT-4: "Çıkış" ipucu (K3 — tüm cihazlardan çıkış) -->
        <template #item="{ item, props }">
          <a v-bind="props.action" :title="item.ipucu || null">
            <span v-if="item.icon" :class="[item.icon, 'p-menu-item-icon']" />
            <span class="p-menu-item-label">{{ item.label }}</span>
          </a>
        </template>
      </Menu>
    </header>

    <div class="flex flex-1 min-h-0">
      <!-- Masaüstü menü -->
      <aside class="admin-sidebar hidden md:flex md:w-64 lg:w-72 h-full flex-col bg-surface-0 dark:bg-surface-900 admin-border-right shrink-0" style="z-index: 60">
        <nav class="flex-1 min-h-0 overflow-y-auto p-2" aria-label="Konsol menüsü">
          <div v-for="g in gorunenGruplar" :key="g.anahtar" class="mb-1">
            <button type="button" class="sk-grup-baslik" :aria-expanded="acikMi(g.anahtar)" @click="grupDegistir(g.anahtar)">
              <i :class="g.ikon" class="sk-grup-ikon"></i>
              <span class="flex-1 text-left">{{ g.ad }}</span>
              <i :class="acikMi(g.anahtar) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="text-xs opacity-60"></i>
            </button>
            <div v-show="acikMi(g.anahtar)" class="flex flex-col gap-0.5 mt-0.5 mb-1">
              <router-link
                v-for="o in g.ogeler"
                :key="o.url"
                :to="o.url"
                class="sk-oge"
                :class="{ 'sk-oge-aktif': ogeAktifMi(o) }"
              >
                <i :class="o.ikon" class="sk-oge-ikon"></i>
                <span class="truncate">{{ o.ad }}</span>
                <i v-if="o.panel" class="pi pi-external-link text-[10px] opacity-50 ml-auto"></i>
              </router-link>
            </div>
          </div>
        </nav>
        <div class="p-3 admin-border-top text-xs text-gray-500 dark:text-gray-400">
          Konsol rolü: <span class="font-medium text-gray-700 dark:text-gray-200">{{ konsol.rolAd || '—' }}</span>
        </div>
      </aside>

      <!-- Mobil menü (PLAN K3 borcu) -->
      <Drawer v-model:visible="drawerAcik" header="Sistem Konsolu" class="!w-80 md:!hidden">
        <nav aria-label="Konsol menüsü">
          <div v-for="g in gorunenGruplar" :key="g.anahtar" class="mb-2">
            <div class="px-2 py-1 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ g.ad }}</div>
            <router-link
              v-for="o in g.ogeler"
              :key="o.url"
              :to="o.url"
              class="sk-oge"
              :class="{ 'sk-oge-aktif': ogeAktifMi(o) }"
              @click="drawerAcik = false"
            >
              <i :class="o.ikon" class="sk-oge-ikon"></i>
              <span>{{ o.ad }}</span>
            </router-link>
          </div>
        </nav>
      </Drawer>

      <main class="flex-1 overflow-auto relative w-full" style="overflow-anchor: auto; scroll-behavior: smooth">
        <div class="h-full p-3 sm:p-4 pb-24 sm:pb-24">
          <!-- Kiracı sayfalarından gelen SayfaBasligi (HepyApp hattı wrapper rotaları) için
               Teleport hedefleri — AdminLayout'taki SayfaBasligiAlani'nın sade karşılığı. -->
          <div v-show="teleportBaslik" class="app-card mb-3 p-4 flex flex-wrap items-center gap-x-3 gap-y-2">
            <span class="text-xl font-bold text-gray-900 dark:text-gray-100">{{ teleportBaslik }}</span>
            <!-- KDU K8: kirli form varken "Kaydedilmedi" rozeti (SayfaBasligiAlani ile aynı) -->
            <span :class="kirli ? 'inline-flex items-center' : 'sr-only'" aria-live="polite">
              <Tag v-if="kirli" class="sk-kirli-rozet" severity="warn" value="Kaydedilmedi" icon="pi pi-pencil" />
            </span>
            <span id="sb-etiket" class="flex items-center gap-2"></span>
            <span class="flex-1"></span>
            <span id="sb-eylem" class="flex flex-wrap items-center gap-2 justify-end"></span>
          </div>
          <router-view v-slot="{ Component, route }">
            <div v-if="Component" :key="route.matched[route.matched.length - 1].path" class="h-full">
              <component :is="Component" />
            </div>
          </router-view>
        </div>
      </main>
    </div>

    <!-- Ctrl+K hızlı sayfa arama -->
    <Dialog v-model:visible="aramaAcik" modal :showHeader="false" :dismissableMask="true" class="w-[36rem] max-w-[calc(100vw-2rem)]" :pt="{ content: { class: '!p-0' } }">
      <div class="p-3 admin-border-bottom flex items-center gap-2">
        <i class="pi pi-search text-gray-400"></i>
        <input
          id="sk-arama-girdi"
          ref="aramaGirdi"
          v-model="aramaMetni"
          type="text"
          class="flex-1 bg-transparent outline-none text-base text-gray-800 dark:text-gray-100"
          placeholder="Sayfa ara… (ör. görev, sipariş, kota)"
          autocomplete="off"
          @keydown.down.prevent="secimKaydir(1)"
          @keydown.up.prevent="secimKaydir(-1)"
          @keydown.enter.prevent="secileneGit"
          @keydown.esc="aramaAcik = false"
        />
        <kbd class="sk-kbd">Esc</kbd>
      </div>
      <ul class="max-h-[60vh] overflow-y-auto p-2" role="listbox">
        <li
          v-for="(s, i) in aramaSonuclari"
          :key="s.url"
          role="option"
          :aria-selected="i === aramaSecili"
          class="sk-arama-satir"
          :class="{ 'sk-arama-secili': i === aramaSecili }"
          @mouseenter="aramaSecili = i"
          @click="git(s)"
        >
          <i :class="s.ikon" class="w-4 text-center text-gray-500"></i>
          <span class="flex-1">{{ s.ad }}</span>
          <span class="text-xs text-gray-400">{{ s.grup }}</span>
        </li>
        <li v-if="aramaSonuclari.length === 0" class="p-4 text-sm text-center text-gray-500">Eşleşen sayfa yok.</li>
      </ul>
    </Dialog>

    <!-- Tek kök ConfirmDialog (AdminLayout emsali). Yoktu: konsoldaki tüm $confirm.require çağrıları
         (Şimdi yedek al, Görevler, Güncellemeler, SQL olay...) hiçbir şey göstermeden yutuluyordu. -->
    <ConfirmDialog />
    <!-- KDU: kaydedilmemiş değişiklik onayı (services/kirliKayit.js), ayrı grup -->
    <ConfirmDialog group="kirli" />
    <!-- SK3-S: sağlayıcı Sparqon'u (düğmesi üst bardaki #sparqon-bar-yuvasi'na ışınlanır) -->
    <SistemSparqon />
  </div>
</template>

<script>
import { SISTEM_MENU, sistemKonsol, rotaGrubu, alanVar, grupAlani } from "@/services/sistemKonsol";
import { uiState } from "@/services/uiState";
import { temaUygula, temaDbye, kayitliTema } from "@/services/tema";
import { boyutUygula, boyutDbye } from "@/services/alanBoyutu";
import { onaySorucuAyarla, onaySorucuKaldir, confirmSorucusu, kirliVarMi, kirliVarMiHemen, cikisOnayiAl, defteriBosalt } from "@/services/kirliKayit";
import SistemSparqon from "@/components/HepyApp/PrivatePage/Sistem/_ortak/SistemSparqon.vue";
import KonsolZil from "@/components/HepyApp/PrivatePage/Sistem/_ortak/KonsolZil.vue";
import { geriGit, geriHedefi } from "@/services/geriNavigasyon";

// SK3-M (KONSOL-V3 §4, V7): 8 grup, grup = yetki anahtarı. Menü tanımı services/sistemKonsol.js'te
// (guard ve Ctrl+K ile ortak). Açık/kapalı grup durumu localStorage.sistemMenu'de; aktif rotanın
// grubu her zaman açılır. Rolün anahtarı olmayan grup hiç çizilmez.
const MENU_ANAHTAR = "sistemMenu";

function trNormal(s) {
  return (s || "").toLocaleLowerCase("tr-TR")
    .replace(/ı/g, "i").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ş/g, "s").replace(/ö/g, "o").replace(/ç/g, "c");
}

export default {
  components: { SistemSparqon, KonsolZil },
  data() {
    let acik = {};
    try { acik = JSON.parse(localStorage.getItem(MENU_ANAHTAR) || "{}") || {}; } catch (e) { acik = {}; }
    return {
      konsol: sistemKonsol,
      acikGruplar: acik,
      drawerAcik: false,
      aramaAcik: false,
      aramaMetni: "",
      aramaSecili: 0,
      kullaniciMenuOgeleri: [
        { label: "Hesabım", icon: "pi pi-user-edit", command: () => this.$router.push("/sistem/hesap") },
        { label: "Bana atanan çağrılar", icon: "pi pi-ticket", command: () => this.$router.push({ path: "/sistem/destek/cagrilar", query: { kuyruk: "bana" } }) },
        { separator: true },
        { label: "Çıkış", icon: "pi pi-sign-out", ipucu: "Tüm cihazlardan çıkış yapar", command: () => this.cikis() },
      ],
    };
  },
  computed: {
    koyuTema() {
      return uiState.koyuTema;
    },
    kucukMu() {
      return uiState.alanBoyutu === "kucuk";
    },
    gorunenGruplar() {
      return SISTEM_MENU.filter((g) => alanVar(grupAlani(g)));
    },
    aktifGrup() {
      const a = rotaGrubu(this.$route.path);
      return SISTEM_MENU.find((g) => g.anahtar === a) || null;
    },
    sayfaAdi() {
      return this.$route.meta.title || "Sistem Konsolu";
    },
    // KGD1 + GBH: panel SayfaBasligiAlani ile aynı kural — her sayfada geri; geçmişsiz açılışta
    // meta.ust, yoksa /sistem/genel (kendisiyse gizli)
    geriVar() {
      return !!geriHedefi(this.$route, "/sistem/genel");
    },
    teleportBaslik() {
      return uiState.sayfaBasligi.baslik;
    },
    // KDU K8: defter reaktif (services/kirliKayit.js) — form kirlenince/temizlenince kendiliğinden
    kirli() {
      return kirliVarMi();
    },
    tumOgeler() {
      const liste = [];
      this.gorunenGruplar.forEach((g) => g.ogeler.forEach((o) => liste.push({ ...o, grup: g.ad })));
      return liste;
    },
    aramaSonuclari() {
      const m = trNormal(this.aramaMetni.trim());
      if (!m) return this.tumOgeler;
      const parcalar = m.split(/\s+/);
      return this.tumOgeler.filter((o) => {
        const hedef = trNormal(o.ad + " " + o.grup);
        return parcalar.every((p) => hedef.includes(p));
      });
    },
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler() {
        if (this.aktifGrup && !this.acikGruplar[this.aktifGrup.anahtar]) {
          this.acikGruplar = { ...this.acikGruplar, [this.aktifGrup.anahtar]: true };
          this._kaydet();
        }
      },
    },
    "konsol.yetkisizUyari": {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.$nextTick(() => {
          this.$toast.add({ severity: "warn", summary: "Yetki yok", detail: v, life: 5000 });
          sistemKonsol.yetkisizUyari = null;
        });
      },
    },
    // SK4-G: panel adresi konsola çevrildiyse kısa bilgi.
    "konsol.panelUyari": {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.$nextTick(() => {
          this.$toast.add({ severity: "info", summary: "Konsola yönlendirildi", detail: v, life: 5000 });
          sistemKonsol.panelUyari = null;
        });
      },
    },
    aramaMetni() {
      this.aramaSecili = 0;
    },
  },
  mounted() {
    this._kirliSorucu = confirmSorucusu(this.$confirm);
    onaySorucuAyarla(this._kirliSorucu);
    window.addEventListener("keydown", this._kisayol);
  },
  beforeUnmount() {
    onaySorucuKaldir(this._kirliSorucu);
    window.removeEventListener("keydown", this._kisayol);
  },
  methods: {
    geriTikla() {
      geriGit(this.$router, this.$route, null, "/sistem/genel");
    },
    // Panelle aynı tercih: anında uygulanır (tema.js localStorage), kullanıcının profiline de yazılır
    // (UpdateKullaniciProfilBilgi token'daki kullanıcıya yazar) — panele geçince aynı tema açılır.
    temaDegistir() {
      const koyu = !uiState.koyuTema;
      temaUygula({ koyu });
      this.$Servis("POST", "UpdateKullaniciProfilBilgi", { KoyuMod: koyu })
        .then((res) => {
          if (res.status !== 200) this.$toast.add({ severity: "warn", summary: "Tema", detail: "Tema tercihi profile kaydedilemedi; bu cihazda geçerli.", life: 3000 });
        })
        .catch(() => {});
    },
    // AB1: anında uygulanır, profile yazılır. BE KoyuMod'u her çağrıda yazdığı için o anki tema da
    // gönderilir — gönderilmezse tema «Sistem»e döner.
    boyutDegistir() {
      const yeni = this.kucukMu ? "normal" : "kucuk";
      boyutUygula(yeni);
      this.$Servis("POST", "UpdateKullaniciProfilBilgi", { KoyuMod: temaDbye(kayitliTema()), AlanBoyutu: boyutDbye(yeni) })
        .then((res) => {
          if (res.status !== 200) this.$toast.add({ severity: "warn", summary: "Alan boyutu", detail: "Alan boyutu profile kaydedilemedi; bu cihazda geçerli.", life: 3000 });
        })
        .catch(() => {});
    },
    acikMi(anahtar) {
      return !!this.acikGruplar[anahtar];
    },
    grupDegistir(anahtar) {
      this.acikGruplar = { ...this.acikGruplar, [anahtar]: !this.acikGruplar[anahtar] };
      this._kaydet();
    },
    _kaydet() {
      try { localStorage.setItem(MENU_ANAHTAR, JSON.stringify(this.acikGruplar)); } catch (e) { /* yok say */ }
    },
    ogeAktifMi(o) {
      if (o.panel) return false;
      const p = this.$route.path.toLowerCase();
      const u = o.url.toLowerCase();
      if (p === u) return true;
      if (!p.startsWith(u + "/")) return false;
      // Daha uzun önekli başka bir öğe varsa (ör. /sistem/sirketler ↔ /sistem/sirketler/yeni) o kazanır.
      return !this.tumOgeler.some((x) => !x.panel && x.url.length > u.length && (p === x.url.toLowerCase() || p.startsWith(x.url.toLowerCase() + "/")));
    },
    _kisayol(e) {
      if ((e.ctrlKey || e.metaKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        this.aramaAc();
      }
    },
    aramaAc() {
      this.aramaMetni = "";
      this.aramaSecili = 0;
      this.aramaAcik = true;
      this.$nextTick(() => setTimeout(() => this.$refs.aramaGirdi && this.$refs.aramaGirdi.focus(), 50));
    },
    secimKaydir(d) {
      const n = this.aramaSonuclari.length;
      if (!n) return;
      this.aramaSecili = (this.aramaSecili + d + n) % n;
    },
    secileneGit() {
      const s = this.aramaSonuclari[this.aramaSecili];
      if (s) this.git(s);
    },
    git(s) {
      this.aramaAcik = false;
      this.$router.push(s.url);
    },
    async cikis() {
      // KDU K6: gönüllü çıkış sorar (AdminLayout.Logout ile aynı)
      if (kirliVarMiHemen() && !(await cikisOnayiAl("sayfa"))) return;
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          // token/user auth/logout'ta (depo) silinir
          localStorage.removeItem("rememberedUsername");
          localStorage.removeItem("sirketLogo");
          defteriBosalt();
          this.$router.push({ path: "/auth/login" }).then(() => window.location.reload());
        })
        .catch(() => { defteriBosalt(); window.location.href = "/auth/login"; });
    },
  },
};
</script>

<style>
/* KDU K8 rozeti: SayfaBasligiAlani #sb-etiket warn rozetiyle aynı (-700/-300, çerçeveli) */
.p-tag.sk-kirli-rozet {
  background: #ffffff;
  border: 1px solid #c2410c;
  color: #c2410c;
}
.my-app-dark .p-tag.sk-kirli-rozet {
  background: #111827;
  border-color: #fdba74;
  color: #fdba74;
}
.sk-ikon-dugme {
  display: inline-flex; align-items: center; justify-content: center;
  width: 2.25rem; height: 2.25rem; border-radius: 0.5rem;
  color: #4b5563;
}
.sk-ikon-dugme:hover { background: #f3f4f6; }
.sk-arama-dugme {
  align-items: center; gap: 0.5rem; height: 2.25rem; padding: 0 0.75rem;
  border: 1px solid #e5e7eb; border-radius: 0.5rem; font-size: 0.875rem; color: #6b7280;
}
.sk-arama-dugme:hover { border-color: #d1d5db; color: #374151; }
.sk-arama-dugme kbd, .sk-kbd {
  font-size: 0.7rem; padding: 0.05rem 0.35rem; border: 1px solid #e5e7eb; border-radius: 0.25rem;
  font-family: inherit; color: #6b7280;
}
.sk-grup-baslik {
  width: 100%; display: flex; align-items: center; gap: 0.5rem; padding: 0.45rem 0.6rem;
  border-radius: 0.5rem; font-size: 0.8rem; font-weight: 600; letter-spacing: 0.02em;
  color: #374151;
}
.sk-grup-baslik:hover { background: #f3f4f6; }
.sk-grup-ikon { font-size: 0.85rem; width: 1rem; text-align: center; color: #9ca3af; }
.sk-oge {
  display: flex; align-items: center; gap: 0.55rem; padding: 0.4rem 0.6rem 0.4rem 1.75rem;
  border-radius: 0.5rem; font-size: 0.85rem; color: #4b5563; transition: background-color .15s;
}
.sk-oge:hover { background: #f3f4f6; }
.sk-oge-ikon { font-size: 0.8rem; width: 1rem; text-align: center; opacity: 0.75; }
.sk-oge-aktif {
  background: var(--type-reformer-bg, #fff7ed) !important;
  color: var(--studio-orange, #ed7a18) !important;
  font-weight: 600;
}
.sk-arama-satir {
  display: flex; align-items: center; gap: 0.6rem; padding: 0.55rem 0.7rem; border-radius: 0.5rem;
  cursor: pointer; font-size: 0.9rem; color: #374151;
}
.sk-arama-secili { background: var(--type-reformer-bg, #fff7ed); color: var(--studio-orange, #ed7a18); }

.dark .sk-ikon-dugme, .my-app-dark .sk-ikon-dugme { color: #cbd5e1; }
.dark .sk-ikon-dugme:hover, .my-app-dark .sk-ikon-dugme:hover,
.dark .sk-grup-baslik:hover, .my-app-dark .sk-grup-baslik:hover,
.dark .sk-oge:hover, .my-app-dark .sk-oge:hover { background: #1f2937; }
.dark .sk-arama-dugme, .my-app-dark .sk-arama-dugme,
.dark .sk-arama-dugme kbd, .my-app-dark .sk-arama-dugme kbd,
.dark .sk-kbd, .my-app-dark .sk-kbd { border-color: #374151; color: #9ca3af; }
.dark .sk-grup-baslik, .my-app-dark .sk-grup-baslik { color: #e5e7eb; }
.dark .sk-oge, .my-app-dark .sk-oge,
.dark .sk-arama-satir, .my-app-dark .sk-arama-satir { color: #cbd5e1; }
.dark .sk-oge-aktif, .my-app-dark .sk-oge-aktif,
.dark .sk-arama-secili, .my-app-dark .sk-arama-secili { background: rgba(237, 122, 24, 0.15) !important; }
</style>
